import React from 'react';
import CustomDropdown from './CustomDropdown';
import Button from './Button';
import { ChevronRight } from 'lucide-react';

const DataPlataformSearch = ({
    exercicios,
    exerciciosSelecionados,
    setExerciciosSelecionados,
    onExerciciosSearch,
    ufs,
    ufsSelecionadas,
    setUfsSelecionadas,
    ufsHasMore,
    onUfsLoadMore,
    onUfsSearch,
    contas,
    contasSelecionadas,
    onContasSearch,
    setContasSelecionadas,
    contasHasMore,
    onContasLoadMore,
    tiposDespesa,
    tiposDespesaSelecionados,
    setTiposDespesaSelecionados,
    onSearch,
    searchLoading,
    isTelaEstado,
    showTipoDespesaFilter = false,
    contaPlaceholder = 'Selecione conta(s)',
}) => (
    <div className='search-container'>
        <div style={{ display: 'flex', gap: 16 }}>
            <CustomDropdown
                placeholder="Selecione o(s) exercícios"
                iconLeft={<img src="/images/icons/calendar_search.svg" alt="" width={18} />}
                options={exercicios}
                selected={exerciciosSelecionados}
                setSelected={setExerciciosSelecionados}
                width="50%"
                onSearch={onExerciciosSearch}
            />
            <CustomDropdown
                placeholder={isTelaEstado ? "Selecione a(s) UF(s)" : "Selecione a(s) UF(s) e/ou municípios"}
                iconLeft={<img src="/images/icons/point_on_map.svg" alt="" width={18} />}
                options={ufs}
                selected={ufsSelecionadas}
                setSelected={setUfsSelecionadas}
                width="50%"
                hasMore={ufsHasMore}
                onLoadMore={onUfsLoadMore}
                onSearch={onUfsSearch}
                isTelaEstado={isTelaEstado}
            />
        </div>
        <CustomDropdown
            placeholder={contaPlaceholder}
            iconLeft={<img src="/images/icons/magnifer.svg" alt="" width={18} />}
            options={contas}
            selected={contasSelecionadas}
            setSelected={setContasSelecionadas}
            width="100%"
            hasMore={contasHasMore}
            onLoadMore={onContasLoadMore}
            onSearch={onContasSearch}
        />
        {showTipoDespesaFilter && (
            <CustomDropdown
                placeholder="Selecione tipo(s) de despesa"
                iconLeft={<img src="/images/icons/filter.svg" alt="" width={18} />}
                options={tiposDespesa}
                selected={tiposDespesaSelecionados}
                setSelected={setTiposDespesaSelecionados}
                width="100%"
            />
        )}
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 8, gap: 8 }}>
            {searchLoading ? (
                <div style={{ padding: 10 }}>
                    <span
                        style={{
                            display: 'inline-block',
                            width: 24,
                            height: 24,
                            border: '3px solid #1976d2',
                            borderTop: '3px solid transparent',
                            borderRadius: '50%',
                            animation: 'spin 1s linear infinite'
                        }}
                    />
                    <style>
                        {`
                @keyframes spin {
                    0% { transform: rotate(0deg);}
                    100% { transform: rotate(360deg);}
                }
                `}
                    </style>
                </div>
            ) : (
                <>
                    <Button
                        label="Pesquisar"
                        variant="primary"
                        iconRight={<ChevronRight />}
                        onClick={() => onSearch(1)}
                    />
                    {(exerciciosSelecionados.length > 0 ||
                        ufsSelecionadas.length > 0 ||
                        contasSelecionadas.length > 0 ||
                        (tiposDespesaSelecionados || []).length > 0) && (
                            <Button
                                label="Limpar filtros"
                                variant="secondary"
                                onClick={() => {
                                    setExerciciosSelecionados([]);
                                    setUfsSelecionadas([]);
                                    setContasSelecionadas([]);
                                    if (setTiposDespesaSelecionados) setTiposDespesaSelecionados([]);
                                }}
                            />
                        )}
                </>
            )}
        </div>
    </div>
);

export default DataPlataformSearch;